import React, { Component } from 'react';
import { OSMHoursEditor } from '../../components';
import s from './HostStyles.module.scss';

export default class OSMHoursEditorHost extends Component {
    constructor(props) {
        super(props);
        this.state = { configuredLinesString: 'Mo-We 09:30-17:30;Th 10:00-15:00' };
    }

    render() {
        return (
            <div className={s.editor} style={{ padding: '100px', width: '500px' }}>
                <OSMHoursEditor configuredLinesString={this.state.configuredLinesString} onChange={configuredLinesString => this.setState({ configuredLinesString })} />
            </div>
        );
    }
}
